import { FC } from "react";

import {
  AGENTIC_AI_CHAT_HISTORY_RETRY,
  AGENTIC_AI_LOAD_MORE_ERROR,
  type ChatListLoadMore
} from "./constants";

export const ChatListSkeletonRow: FC<{ titleWidth?: string }> = ({
  titleWidth = "w-3/4"
}) => (
  <li
    aria-hidden
    data-testid="chat-history-skeleton"
    className="flex animate-pulse flex-col px-2 py-2 motion-reduce:animate-none"
  >
    <span className={`my-[3px] h-3.5 rounded bg-gainsboro ${titleWidth}`} />
  </li>
);

const ChatListLoadMoreFooter: FC<{ loadMore: ChatListLoadMore }> = ({
  loadMore
}) => (
  <>
    {loadMore.isError ? (
      <li className="flex flex-col items-start gap-1 px-2 py-2 text-xs text-txtBody">
        {AGENTIC_AI_LOAD_MORE_ERROR}
        <button
          type="button"
          onClick={loadMore.onRetry}
          className="font-semibold text-teal-500 hover:underline"
        >
          {AGENTIC_AI_CHAT_HISTORY_RETRY}
        </button>
      </li>
    ) : (
      <li aria-hidden ref={loadMore.ref} />
    )}

    {loadMore.isFetching && <ChatListSkeletonRow />}
  </>
);

export default ChatListLoadMoreFooter;
